
import { sampleForm$Designer } from '../../designerFiles/renderer/controls/sampleForm.uc.designer.js';
export class sampleForm extends sampleForm$Designer{    
    /** 
     *  CALLED AFTER COMPLETE INITIALIZATION WITH ARGUMENTS PASSED in static `Create` Method
     */
    async $() {  // USE THIS METHOD TO DECLARE YOUR `constructor` 
        
    }
}